'use strict';

window.jQuery = window.$ = require('jquery');

var phantomJs = require('./phantomjs'),
    angular = require('angular'),
    uiRouter = require('angular-ui-router'),
    ngTouch = require('angular-touch'),
    ngCookies = require('angular-cookies'),
    /**
     * Application external dependencies
     * @type {string[]}
     */
    externalDependencies,
    /**
     * Application components
     * @type {string[]}
     */
    components,
    /**
     * Application dependencies (merged)
     * @type {string[]}
     */
    dependencies;

require('angular-translate'); // require angular-translate (it doesn't return a module name)
require('angular-translate/dist/angular-translate-loader-static-files/angular-translate-loader-static-files');
require('angular-translate-handler-log/angular-translate-handler-log');
require('angulartics');
require('angulartics-google-analytics');
require('angular-bootstrap-npm');
require('angular-inview');
require('./vendor/angular-smooth-scroll');
require('./vendor/angular-parallax');

externalDependencies = [
    'tpl', // html templates bundle
    'pascalprecht.translate',
    'ui.bootstrap',
    'angulartics',
    'angulartics.google.analytics',
    'smoothScroll',
    'angular-parallax',
    'angular-inview',
    uiRouter,
    ngTouch,
    ngCookies
];

components = [
    require('common/header').name,
    require('common/footer').name,
    require('components/home').name
];

dependencies = externalDependencies.concat(components);

// module configuration
module.exports = angular.module('App', dependencies)
    .constant('isPhantomJs', phantomJs.isPhantomJs)
    .controller('AppController', require('./app.ctrl'))
      .config(['$translateProvider', function ($translateProvider) {

      $translateProvider
            .registerAvailableLanguageKeys(['en', 'pl'], {
                'en': 'en',
                'en-us': 'en',
                'en_US': 'en',
                'en-US': 'en',
                'en_UK': 'en',
                'en-gb': 'en',
                'pl': 'pl',
                'pl-gb': 'pl',
                'pl_PL': 'pl',
                'pl-pl': 'pl'
            })
            .determinePreferredLanguage()
            .useStaticFilesLoader({
                prefix: 'app/lang/',
                suffix: '.json'
            })
            .useLoaderCache(true)
            .useSanitizeValueStrategy('escapeParameters')
            .useMissingTranslationHandlerLog();
      }])
    .config(function (
        $stateProvider,
        $urlRouterProvider,
        $urlMatcherFactoryProvider,
        $locationProvider
    ) {

        $locationProvider.hashPrefix = '!';
        $locationProvider.html5Mode(true);

        // for any unmatched url, redirect to home url
        $urlRouterProvider.otherwise('/');

        // set up the root state
        $stateProvider.state({
            name: 'root',
            abstract: true,
            views: {
                header: {
                    templateUrl: 'common/header/header.tpl.html',
                    controller: 'HeaderController as headerCtrl'
                },
                footer: {
                    templateUrl: 'common/footer/footer.tpl.html',
                    controller: 'FooterController as footerCtrl'
                }
            },
            resolve: {

            }
        });

    });
